module.exports = __webpack_public_path__ + "img/TUV.e5f17ad0.svg";